import PropTypes from 'prop-types';
import React from 'react';
import FontAwesome from 'react-fontawesome';
import { Trans } from 'lingui-react';

import { A } from 'base-components';

import RepairInstructionsIconWrapper from './RepairInstructionsIconWrapper';
import messages from './messages';


function RepairInstructionsLink({ href }) {
  return (
    <A href={href}>
      <RepairInstructionsIconWrapper>
        <FontAwesome name="file-pdf-o" />
      </RepairInstructionsIconWrapper>
      <Trans id={messages.viewRepairInstructions} />
    </A>
  );
}

RepairInstructionsLink.propTypes = {
  href: PropTypes.string.isRequired,
};

export default RepairInstructionsLink;



// WEBPACK FOOTER //
// ./compositions/DiagnosticsWidget/DiagnosticsComponent/CaseFault/RepairInstructionsLink.js